export default __webpack_public_path__ + "static/media/sort-az.327f8888.svg";